<div *ngIf="formGroupEmpleado && formGroupUsuario && formGroupPerfil" class="main-content profile-editor-page employee-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ tituloOperacion }} de Empleado</h1>
        <p>Capture datos personales, acceso y perfiles del personal sin salir del flujo de gestión.</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="onClicCerrarModal()">
          Regresar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary"
          (click)="onClicGuardar()"
          [disabled]="formGroupEmpleado?.invalid || formGroupUsuario?.invalid || !perfilesValidos || isSaving">
          Guardar empleado
        </button>
      </div>
    </section>

    <div class="employee-editor-page__content">
      <div class="row employee-editor-page__top-grid">
        <div class="col-xl-7 col-lg-7 employee-editor-page__column employee-editor-page__column--stacked">
          <section class="profile-editor-page__card">
            <div class="profile-editor-page__card-header">
              <div class="employee-editor-page__card-copy">
                <div class="profile-editor-page__card-title">
                  <i class="material-icons">badge</i>
                  <span>Datos del Empleado</span>
                </div>
                <span>Capture la información base del colaborador y su ubicación operativa.</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <form [formGroup]="formGroupEmpleado" class="employee-editor-page__form">
                <div class="row employee-editor-page__grid">
                  <div class="col-md-4">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="nombreEmpleado">Nombre <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="text"
                        id="nombreEmpleado"
                        name="nombreEmpleado"
                        maxlength="30"
                        [(ngModel)]="objectEmpleado.persona.nombre"
                        formControlName="controlNombre" />
                      <mat-error *ngIf="formGroupEmpleado.controls.controlNombre.touched && formGroupEmpleado.controls.controlNombre.invalid">
                        Capture el nombre del empleado.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="aPaterno">Apellido paterno <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="text"
                        id="aPaterno"
                        name="aPaterno"
                        maxlength="25"
                        oninput="this.value = this.value.trim()"
                        [(ngModel)]="objectEmpleado.persona.apellidoPaterno"
                        formControlName="controlAPaterno" />
                      <mat-error *ngIf="formGroupEmpleado.controls.controlAPaterno.touched && formGroupEmpleado.controls.controlAPaterno.invalid">
                        Capture el apellido paterno.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="aMaterno">Apellido materno <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="text"
                        id="aMaterno"
                        name="aMaterno"
                        maxlength="25"
                        oninput="this.value = this.value.trim()"
                        [(ngModel)]="objectEmpleado.persona.apellidoMaterno"
                        formControlName="controlAMaterno" />
                      <mat-error *ngIf="formGroupEmpleado.controls.controlAMaterno.touched && formGroupEmpleado.controls.controlAMaterno.invalid">
                        Capture el apellido materno.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="email">Correo electr&oacute;nico <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="email"
                        id="email"
                        name="email"
                        maxlength="60"
                        oninput="this.value = this.value.trim()"
                        [(ngModel)]="objectEmpleado.persona.correoelectronico"
                        formControlName="controlEmail" />
                      <mat-error *ngIf="formGroupEmpleado.controls.controlEmail.touched && formGroupEmpleado.controls.controlEmail.invalid">
                        Capture un correo válido.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="fechaNacimiento">Fecha de nacimiento</label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        id="fechaNacimiento"
                        name="fechaNacimiento"
                        [matDatepicker]="dateStart"
                        formControlName="controlFechaNac"
                        [(ngModel)]="objectEmpleado.persona.fechaNacimiento"
                        [max]="maxDate" />
                      <mat-datepicker-toggle matSuffix [for]="dateStart"></mat-datepicker-toggle>
                      <mat-datepicker #dateStart></mat-datepicker>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="employee-editor-page__field-wrap">
                      <label id="labelAreaEmpleado" class="employee-editor-page__field-label" for="areaEmpleado">Área <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-select
                        id="areaEmpleado"
                        aria-labelledby="labelAreaEmpleado"
                        [(ngModel)]="objectEmpleado.puesto.id_area"
                        formControlName="controlArea"
                        (selectionChange)="onAreaChange($event.value)">
                        <mat-option *ngFor="let areaObject of listArea" [value]="areaObject.id">
                          {{ areaObject.area }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="formGroupEmpleado.controls.controlArea.touched && formGroupEmpleado.controls.controlArea.invalid">
                        Seleccione un área.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="employee-editor-page__field-wrap">
                      <label id="labelPuestoEmpleado" class="employee-editor-page__field-label" for="puestoEmpleado">Puesto <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-select id="puestoEmpleado" aria-labelledby="labelPuestoEmpleado" [(ngModel)]="objectEmpleado.idPuesto" formControlName="controlPuesto">
                        <mat-option *ngFor="let puestoObject of listPuestos" [value]="puestoObject.id">
                          {{ puestoObject.puesto }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="formGroupEmpleado.controls.controlPuesto.touched && formGroupEmpleado.controls.controlPuesto.invalid">
                        Seleccione un puesto.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </section>

          <section class="profile-editor-page__card employee-editor-page__card--access">
            <div class="profile-editor-page__card-header">
              <div class="employee-editor-page__card-copy">
                <div class="profile-editor-page__card-title">
                  <i class="material-icons">vpn_key</i>
                  <span>Acceso y Credenciales</span>
                </div>
                <span>Defina el usuario y la contraseña de acceso administrativo.</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <form [formGroup]="formGroupUsuario" class="employee-editor-page__form">
                <div class="row employee-editor-page__grid">
                  <div class="col-12">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="usuario">Usuario <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="text"
                        id="usuario"
                        name="usuario"
                        maxlength="20"
                        oninput="this.value = this.value.trim()"
                        [(ngModel)]="objectEmpleado.usuario.user_nom"
                        formControlName="controlUsuario" />
                      <mat-error *ngIf="formUsuar.controlUsuario.touched && formUsuar.controlUsuario.errors">
                        El usuario debe tener al menos 5 caracteres.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="contrasenia">Contraseña <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="password"
                        id="contrasenia"
                        name="contrasenia"
                        maxlength="20"
                        oninput="this.value = this.value.trim()"
                        [(ngModel)]="objectEmpleado.usuario.password"
                        formControlName="controlPass" />
                      <mat-error *ngIf="formUsuar.controlPass.touched && formUsuar.controlPass.errors">
                        La contraseña debe tener al menos 6 caracteres.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="employee-editor-page__field-wrap">
                      <label class="employee-editor-page__field-label" for="contrasenia2">Confirmar contraseña <span class="employee-editor-page__required" aria-hidden="true">*</span></label>
                      <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <input
                        matInput
                        type="password"
                        id="contrasenia2"
                        name="contrasenia2"
                        maxlength="20"
                        oninput="this.value = this.value.trim()"
                        formControlName="controlRePass" />
                      <mat-error *ngIf="formUsuar.controlRePass.touched && formUsuar.controlRePass.errors">
                        Las contraseñas deben coincidir.
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>
                </div>
              </form>

              <div class="employee-editor-page__support" *ngIf="isEditMode">
                <i class="material-icons">info</i>
                <div class="employee-editor-page__support-copy">
                  <strong>Edición segura</strong>
                  <span>Si no cambia la contraseña, se conservará la actual del usuario.</span>
                </div>
              </div>

              <!-- Solo si la persona tiene PIN de autorización y quien edita administra Empleados -->
              <app-pin-restablecer
                *ngIf="isEditMode"
                [idUsuario]="objectEmpleado.usuario.id"
                [nombre]="objectEmpleado.persona.nombreCompleto">
              </app-pin-restablecer>
            </div>
          </section>
        </div>

        <div class="col-xl-5 col-lg-5 employee-editor-page__column">
          <section class="profile-editor-page__card employee-editor-page__card--profiles">
            <div class="profile-editor-page__card-header profile-editor-page__card-header--tree">
              <div class="employee-editor-page__card-copy">
                <div class="profile-editor-page__card-title">
                  <i class="material-icons">supervised_user_circle</i>
                  <span>Perfiles</span>
                </div>
                <span>Defina los accesos operativos del usuario.</span>
              </div>

              <div class="profile-editor-page__tree-meta">
                <span class="profile-editor-page__counter">{{ selectedProfilesCount }} seleccionados</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <form [formGroup]="formGroupPerfil" class="employee-editor-page__form">
                <div
                  class="employee-editor-page__selection-hint"
                  *ngIf="listPerfiles.length > 0 && hayCatalogoBiometrico">
                  <i class="material-icons">fingerprint</i>
                  <span>«No aplica» niega el acceso al kiosco y es excluyente: al marcarlo se desmarcan los demás perfiles biométricos.</span>
                </div>

                <div class="employee-editor-page__selection-wrap" *ngIf="listPerfiles.length > 0; else perfilesEmptyState">
                  <mat-selection-list
                    class="employee-editor-page__selection-list"
                    formControlName="controlPerfiles"
                    (selectionChange)="validaPerfiles($event)">
                    <ng-container *ngFor="let grupo of gruposPerfiles">
                      <div
                        mat-subheader
                        class="employee-editor-page__selection-group"
                        *ngIf="gruposPerfiles.length > 1">
                        {{ grupo.sitio }}
                      </div>
                      <mat-list-option
                        *ngFor="let perfilObject of grupo.perfiles"
                        [value]="perfilObject">
                        <div class="employee-editor-page__selection-item">
                          <div class="employee-editor-page__selection-copy">
                            <strong>{{ perfilObject.nombre }}</strong>
                          </div>
                          <span
                            class="employee-editor-page__selection-chip"
                            [class.employee-editor-page__selection-chip--biometrico]="esPerfilBiometrico(perfilObject)">
                            {{ perfilObject.sitio }}
                          </span>
                        </div>
                      </mat-list-option>
                    </ng-container>
                  </mat-selection-list>
                </div>

                <ng-template #perfilesEmptyState>
                  <div class="profile-editor-page__empty-state employee-editor-page__empty-state">
                    <i class="material-icons">layers_clear</i>
                    <strong>No hay perfiles disponibles</strong>
                    <span>Intente más tarde o valide la configuración de perfiles antes de continuar.</span>
                  </div>
                </ng-template>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
